import { IEstatutoFormPayload, IEstatutoPasso } from '../../hooks/useEstatuto';

export type StepKey = 1 | 2 | 3 | 4;

export const STEP_TITLES: Record<StepKey, string> = {
  1: 'Identidade da turma',
  2: 'Regras e prazos',
  3: 'Fundadores e diretoria',
  4: 'Assembleia de fundação',
};

export const STEP_DESCRIPTIONS: Record<StepKey, string> = {
  1: 'Informações básicas sobre a turma, instituição e contato.',
  2: 'Regras de funcionamento da comissão, prazos e periodicidades.',
  3: 'Todos os fundadores, com o cargo de quem foi eleito para a diretoria.',
  4: 'Dados da assembleia que aprovou o estatuto e a revisão final.',
};

export const STEPS = Object.keys(STEP_TITLES).map(Number) as StepKey[];
export const ULTIMO_PASSO = STEPS[STEPS.length - 1];

export const FIELDS_BY_STEP: Record<StepKey, (keyof IEstatutoFormPayload)[]> = {
  1: [
    'numero_turma',
    'nome_curso',
    'nome_instituicao',
    'semestre_formatura',
    'endereco_sede',
    'canal_comunicacao',
    'cidade_assinatura',
  ],
  2: [
    'vigencia_inicio',
    'vigencia_fim',
    'periodicidade_balancete',
    'balancete_trimestral_ate',
    'periodicidade_balanco',
    'periodicidade_aprovacao_contas',
    'minimo_cargos_diretoria',
    'reunioes_consecutivas_abandono',
    'reunioes_alternadas_abandono',
    'periodo_reunioes_alternadas',
    'prazo_contestacao_dias',
    'limite_assembleias_extraordinarias',
    'prazo_devolucao_dias',
    'prazo_devolucao_desistencia_dias',
    'ano_limite_admissao',
    'prazo_limite_migracao_plano_anos',
    'eventos_formatura',
    'confirma_inexistencia_orgaos',
  ],
  3: ['pessoas'],
  4: [
    'data_assembleia',
    'data_requerimento',
    'votos_favor',
    'votos_contra',
    'total_eleitores',
    'presidente_trabalhos_cpf',
    'secretario_trabalhos_cpf',
  ],
};

// Passos da constituição (a Baixa recebe os dela do back, por etapa): o formulário e a lista
// das perguntas do módulo.
export const PASSOS_CONSTITUICAO: IEstatutoPasso[] = STEPS.map(k => ({
  titulo: STEP_TITLES[k],
  descricao: STEP_DESCRIPTIONS[k],
  campos: FIELDS_BY_STEP[k],
}));
